import './index.css';
import './i18n';

import NiceModal from '@ebay/nice-modal-react';
import * as Sentry from '@sentry/react';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { createStore } from 'jotai';
import { Provider } from 'jotai';
import { DevTools } from 'jotai-devtools';
import css from 'jotai-devtools/styles.css?inline';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';

import AliPayWarningModal from '@/components/modals/alipay-warning-modal';
import ECNYTutorialModal from '@/components/modals/ecny-tutorial-modal';
import ECNYWarningModal from '@/components/modals/ecny-warning-modal';
import TransitionCancelModal from '@/components/modals/transition-cancel-modal';
import TransitionImageUploadModal from '@/components/modals/transition-image-upload-modal';

import { version } from '../package.json';
import { routeTree } from './routeTree.gen';

Sentry.init({
  dsn: 'https://3c5ae4324ba6b41c9d5f93b7e2895d37@sentry-sgp.pstdsf.com/3',
  environment: `${import.meta.env.VITE_BRAND || 'unknown'}-${import.meta.env.VITE_ENVIRONMENT || 'unknown'}`,
  release: `paybox-web-v2@${version}`,
  sendDefaultPii: true,
  ignoreErrors: ['TypeError: Failed to fetch'],
});

const router = createRouter({ routeTree });

NiceModal.register('ecny-tutorial-modal', ECNYTutorialModal);
NiceModal.register('ecny-warning-modal', ECNYWarningModal);
NiceModal.register('alipay-warning-modal', AliPayWarningModal);
NiceModal.register('transition-cancel-modal', TransitionCancelModal);
NiceModal.register('transition-image-upload-modal', TransitionImageUploadModal);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const customStore = createStore();

const JotaiDevTools = () =>
  process.env.NODE_ENV !== 'production' ? (
    <>
      <style>{css}</style>
      <DevTools store={customStore} />
    </>
  ) : null;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={customStore}>
      <Toaster position="top-center" />
      <NiceModal.Provider>
        <RouterProvider router={router} />
      </NiceModal.Provider>
      {/* <JotaiDevTools /> */}
    </Provider>
  </StrictMode>
);
